import templateUrl from './about-us-our-staff.html';
import head from 'lodash/head';

export const aboutUsOurStaffComponent = {
	templateUrl,

	bindings: {
		details: '<'
	},

	controller: class AboutUsOurStaffComponent {
		constructor(ApiService, $state, OurStaffService) {
			'ngInject';

			this.apiService = ApiService;
			this.$state = $state;
			this.ourStaffService = OurStaffService;
		}

	// ################################################# PUBLIC METHODS ###################################################################

		$onInit() {
			this.details = this.ourStaffService.getOurStaffDetails(this.details);
			this.contactNumbers = head(this.details.contact);
			this.primaryContactNumber = head(this.contactNumbers);
		}

		getImage(image) {
			return image ? this.apiService.getResourceUrl(`files/images/${image}`) : '/./images/Staff_default.jpg';
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/components/about-us-our-staff/about-us-our-staff.component.js